import React from "react";

const ServiceIntro = () => {
  return (
    <div className="flex flex-col items-center justify-center text-center py-12">
      {/* Büyük Logo */}
      <img
        src="/images/logo.png"
        alt="Logo"
        className="w-[885px] h-auto mb-6"
      />
      <h2 className="text-black text-2xl font-bold">İstanbul'NIN PROFESYONEL TEMİZLİK ÇÖZÜMLERİ </h2>
      {/* Açıklama Metni */}
      <p className="text-gray-800 text-lg font-bold mx-11">
        İstanbul genelinde hizmet veren İstanbul Temizlik Servisi ev ve iş yerlerinin
        temizlik ihtiyaçlarına yönelik uzman çözümler sunar. Modern ekipman,
        hijyenik uygulamalar ve müşteri memnuniyeti odaklı yaklaşımıyla,
        temizlik artık sizin için zahmetsiz bir hizmete dönüşüyor.
      </p>
    </div>
  );
};

export default ServiceIntro;
